module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-1-updated-00346648416937ccbf2528bb4258aab0.webp";